export const chatDefaultSize = [320, 500];

export const CHAT_WINDOW_HEADER_HEIGHT = 58;
